import script from "./CourseScheduling.vue?vue&type=script&setup=true&lang=ts"
export * from "./CourseScheduling.vue?vue&type=script&setup=true&lang=ts"

import "./CourseScheduling.vue?vue&type=style&index=0&id=9f95bd96&scoped=true&lang=css"

import exportComponent from "D:\\project\\CDM_QR-Access-Control-System-3\\DoorWebApp_Vue\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-9f95bd96"]])

export default __exports__